window.testEnv = process.env.NODE_ENV;

/**
 * Дорисовка jQuery в глобальном виде
 * Отключил поскольку ниже стоячии библиотеки требуют определенной видимости
 */

if (0) {
    const jQuery =
    window.$ =
    window.jQuery = require('./jquery-3.3.1.min.js');
    const $ = jQuery; 
}


console.log(typeof define);


if(window.testEnv === 'production') {
	window.ProjectVersion = PROJECT_VERSION;
	if(window.ProjectVersion){
		console.log('project version = ' + window.ProjectVersion);
	}
}
/*
Підключаєм тільки ті стилі, які будуть на всіх сторінках
*/
require('__scss/grid.scss');					    // сітка
require('__scss/text.scss');					    // стилі тектсу
require('__scss/fonts.scss');					// шрифти
require('__scss/awesome.scss');					// іконци

require('perfect-scrollbar/dist/css/perfect-scrollbar.css');	// perfect scrollbar
require('__scss/slick.scss'); 					// slick
// require('__scss/slick-theme.scss');
// material design
require('__scss/nouislider.css');
window.noUiSlider = require('nouislider');


// require('__scss/materialize_form_date/materialize.scss');

/**
 * Где-то в этом модуле месте сатана делает подключение к jQuery
 */
require('__scss/materialize.scss');
require('materialize-css');


// window.$ = window.jQuery;
// var jqueryLib = require('./libs/jquery-3.3.1.min.js');
// console.log(jqueryLib);
// window.$ = jqueryLib;
// window.jQuery = jqueryLib;

// require('perfect-scrollbar/jquery')($);

// const jQuery = require('jquery');
const fancybox = require('./jquery.fancybox.js');

// window.jQuery = jQuery;
// window.$ = jQuery;
window.fancybox = fancybox;
window.Inputmask = require('inputmask');
window.perfectScrollbar = require('perfect-scrollbar/jquery')($);

require('__libs/validator.js');
require('__libs/share.js');

//popup forma инициализация photo
require('__libs/inputTypeFile.js');
require('__libs/addDomElement.js');
require('__libs/data-yam-popup.js');

// fixed header
require('__libs/fixed-header.js');
//полифил для шапки сайта браузеры Safari IE
require('intersection-observer');


//скрипт для страницы rating.html
// let yamRatingElement = document.querySelectorAll('[data-yam-rating]');
// if(yamRatingElement.length) {
//     for(var i = 0; i < yamRatingElement.length; i++) {
//         if ($( '[data-yam-rating]' ).attr('data-yam-rating') !== "true") {
//             $('[data-yam-rating]').addClass('disabled');
//         }
//     }
// }
require('owl.carousel/src/scss/owl.carousel.scss');
require('owl.carousel/src/scss/owl.theme.default.scss');
require('owl.carousel');


const mc = {
    runVue: function(array) {
        if(array && array.length) {
            window.VueInstances = {};
    
            Vue.use(VueResource);
    
            array.map(component => {
                Vue.component(component, require(`__components/${component}.vue`));
                window.VueInstances[component] = {};
            });
            const components = document.querySelectorAll('[is]');
    
            // шукаєм всі діви із атрибутом "is" та запускаєм компоненти
            for(let i = 0; i < components.length; i++) {
                // перевіряєм, чи включений компонент в процес збірки проекту
                if(window.VueInstances[components[i].getAttribute('is')]) {
                    if(components[i].getAttribute('data-params')) {
                        let str = components[i].getAttribute('data-params');
                        str = str.replace(/'/g, '"');
                        let params = JSON.parse(str);
                        window.VueInstances[components[i].getAttribute('is')][params.template] = new Vue({ el: components[i] });
                        // console.log({ el: components[i] });
                    } else {
                        console.warn('dataParams is no defined', components[i]);
                    }
                } else {
                    console.warn(`Component ${components[i].getAttribute('is')} is not enabled, but used! Check module constructor options.`);
                }
            }
        }
    },
    runComponents: function(arComponents) {
        if (arComponents && arComponents.length > 0) {
            arComponents.map(componentName => {
                if (typeof this[componentName] === 'undefined') {
                    this[componentName] = require('__libs/'+componentName);
                }
            });
        }
    },
    runFooter: function() {
        STACK.forEach(f => {
            f($);
        });

        // запускаєм скріпти які повинні запускатися при ajax
        $("body").trigger('ajaxResponse');
    }
}
module.exports = mc;
NodeList.prototype.forEach = function(f) {
	for(var i = 0; i < this.length; i++) {
		f(this[i], i);
	}
};


// WEBPACK FOOTER //
// ./libs/ModuleConstructor.js